import HomeIcon from "../assets/icons/sidebarIcons/homeIcon.svg";
import TestIcon from "../assets/icons/sidebarIcons/testIcon.svg";
import QuestionIcon from "../assets/icons/sidebarIcons/questionIcon.svg";
import LessonIcon from "../assets/icons/sidebarIcons/lessonIcon.svg";
import ReportIcon from "../assets/icons/sidebarIcons/reportIcon.svg";
import AwardIcon from "../assets/icons/sidebarIcons/awardIcon.svg";
import MenuIcon from "../assets/icons/sidebarIcons/menuIcon.svg";
import MenuIconActive from "../assets/icons/sidebarIcons/menuIconactive.svg";
import OtherIcon from "../assets/icons/sidebarIcons/secondaryMenu.svg";
export const sidebarDesktopItems = [
  {
    name: "Home",
    path: "/",
    icon: HomeIcon,
  },
  {
    name: "Akıllı Test",
    path: "/",
    icon: MenuIcon,
    url: "/smarttest",
  },
  {
    name: "Çözülmüş Testler",
    path: "/",
    icon: TestIcon,
  },
  {
    name: "İşaretli Sorular",
    path: "/",
    icon: QuestionIcon,
  },
  {
    name: "Ders Özeti",
    path: "/",
    icon: LessonIcon,
  },
  {
    name: "Raporlarım",
    path: "/",
    icon: ReportIcon,
  },
  {
    name: "Genel Sıralama",
    path: "/",
    icon: AwardIcon,
  },
];

export const sidebarMobileItems = [
  {
    name: "Ana sayfa",
    path: "/",
    icon: HomeIcon,
    active: false,
  },
  {
    name: "Akıllı Test",
    path: "/",
    icon: MenuIconActive,
    active: true,
  },
  {
    name: "Ders Özeti",
    path: "/",
    icon: LessonIcon,
    active: false,
  },
  {
    name: "Sıralama",
    path: "/",
    icon: AwardIcon,
    active: false,
  },
  {
    name: "Diğer",
    path: "/",
    icon: OtherIcon,
    active: false,
  },
];
